import Alpine from "alpinejs";
import Clipboard from '@ryangjchandler/alpine-clipboard';
import { countries } from '@cleardesignuk/countries-helper';

import "./js/theme";
import "./js/alpine-store";
import "./js/alpine-money";

window.Alpine = Alpine;

window.countries = countries;

Alpine.plugin(Clipboard);
Alpine.start();
